/**
 * The assistant panel. Grounded in the Lifelong POS knowledge base once the RAG build lands; the
 * panel, its context chips and its thread layout exist now so the workspace is shaped around it.
 * Nothing it writes reaches a merchant without a rep's confirm (hard rule).
 */
import { Sparkles } from 'lucide-react';

export interface AssistantContext {
  label: string;
}

export function AssistantPanel({ context }: { context: AssistantContext[] }) {
  return (
    <aside aria-label="Assistant" className="flex h-full w-[360px] shrink-0 flex-col border-l border-line bg-surface">
      <div className="flex h-10 items-center gap-2 border-b border-line px-4">
        <Sparkles className="size-4 text-ink-3" />
        <span className="text-body font-medium">Assistant</span>
        <span className="ml-auto text-hint text-ink-3">Lifelong POS knowledge base</span>
      </div>

      <div className="flex flex-wrap gap-1.5 border-b border-line px-4 py-2.5">
        <span className="text-hint text-ink-3">Grounded in</span>
        {context.length === 0 ? (
          <span className="text-hint text-ink-2">nothing yet, open an account or a ticket</span>
        ) : (
          context.map((c) => (
            <span key={c.label} className="rounded-full border border-line bg-surface-2 px-2 text-hint text-ink-2">
              {c.label}
            </span>
          ))
        )}
      </div>

      <div className="flex flex-1 flex-col justify-end gap-3 overflow-auto px-4 py-4">
        <p className="text-body text-ink-2">
          Ask about a terminal error, an update flow, a settlement question, or what to try before an RMA. Answers cite the knowledge base article they came from.
        </p>
        <p className="text-hint text-ink-3">The assistant is not switched on yet. Drafts for merchants will always wait for your confirm.</p>
      </div>

      <div className="border-t border-line p-3">
        <textarea
          disabled
          rows={1}
          aria-label="Ask the assistant"
          placeholder="Not switched on yet"
          className="block h-9 w-full resize-none rounded-control border border-line bg-surface-2 px-3 py-2 text-body text-ink placeholder:text-ink-3 disabled:cursor-not-allowed disabled:opacity-70"
        />
      </div>
    </aside>
  );
}
